import React from "react";
import withCompose from "./utils";
import Header from "./Header";
import ModalClass from "@gqlapp/base/Modal/ModalClass";
import RenderSlider from "@gqlapp/fields/Slider";
import Field from "@gqlapp/forms-client-react/FieldAdapter";
import clsx from 'clsx';
import Row from "@gqlapp/base/Row";
import Col from "@gqlapp/base/Col";
import Box from '@mui/material/Box';
import Group from "@gqlapp/utils/Group";

function baseForm(props) {
	const BaseForm = withCompose
	((props) => {

		let { sx, values, className, setFieldValue } = props;


		let group = {
			...sx,
			paddingleft: '15px',
			paddingRight: '15px',
			paddingBottom: '0px',
			'& .MuiFormGroup-root':{ minHeight: '30px' },
		}



		function sliderConfig(props){
			return {
				className: clsx('slider', 'crop-slider', 'd-flex align-items-center'),
				onBlur: () => {},
				onFocus: () => {},
				component: RenderSlider,
				onChange: setFieldValue,
				...props
			}
		}


		const marks = [
			{ value: 1, label: '7%' },
			{ value: 0, label: '15%' },
			{ value: 2, label: '25%' },
			{ value: 3, label: '30%' }
		];

		return (<ModalClass
			{...props}
			{...{contentProps: {sx}, className}}
			{...{ className, header: Header }}
		>
			<Group sx={group}>
				<Row>
					<Col>{`qr:qrcode.dataSize.title`.t()}</Col>
					<Col xs={'auto'} className={'d-flex align-items-center'} sx={{width: '130px !important'}}>
						<Box {...{sx: { width: '100%' }}}>
							<Field {...sliderConfig({
								marks, step: null,
								name: 'correctLevel', value: values?.correctLevel, min: 0, max: 3
							})} />
						</Box>
					</Col>
				</Row>

				<Row>
					<Col>{`qr:qrcode.dataSize.title`.t()}</Col>
					<Col xs={'auto'} className={'d-flex align-items-center'} sx={{width: '130px !important'}}>
						<Box {...{sx: { width: '100%' }}}>
							<Field {...sliderConfig({
								name: 'size',
								value: values?.size, min: 30, max: 100, step: 1
							})} />
						</Box>
					</Col>
				</Row>
				<Row>
					<Col>{`qr:qrcode.strokeWidth.title`.t()}</Col>
					<Col xs={'auto'} className={'d-flex align-items-center'} sx={{width: '130px !important'}}>
						<Box {...{sx: { width: '100%' }}}>
							<Field {...sliderConfig({
								name: 'strokeWidth',
								value: values?.strokeWidth, min: 0, max: 100, step: 1
							})} />
						</Box>
					</Col>
				</Row>
			</Group>
		</ModalClass>)
	});

	return <BaseForm {...props} />
}


export default baseForm;